import axios from "axios";
import { buildRequests } from "../util/buildRequest";
import { DOMAIN } from "../util/constants";
import { SetAuthHeader } from "../util/SetAuthHeader";
import { SetLanguageHeader } from "../util/SetLanguageHeader";

// ============================================================================
// Base Axios Instance Setup
// ============================================================================

const API = `${DOMAIN}/api/v1`;
const instance = axios.create({
  baseURL: API,
});

instance.interceptors.request.use(SetAuthHeader);
instance.interceptors.request.use(SetLanguageHeader);

const requests = buildRequests(instance);

export { API as NOTIFICATIONS_API, requests as notifications_api_requests };

// ============================================================================
// Re-export all TypeScript Interfaces and Types
// ============================================================================

// Channel types
export type {
  NotificationChannel,
  NotificationChannelConfig,
} from "./channels";

// Provider types
export type {
  NotificationProvider,
  NotificationProviderStatus,
} from "./providers";

// Template types
export type {
  NotificationTemplate,
  CreateNotificationTemplateRequest,
  UpdateNotificationTemplateRequest,
} from "./templates";

// ============================================================================
// Re-export Query Keys
// ============================================================================

export { NOTIFICATION_CHANNELS_QUERY_KEY } from "./channels";
export { NOTIFICATION_PROVIDERS_QUERY_KEY } from "./providers";
export { NOTIFICATION_TEMPLATES_QUERY_KEY } from "./templates";

// ============================================================================
// Re-export all Hooks for Backward Compatibility
// ============================================================================

// Channel hooks
export {
  useGetChannelConfigs,
  useGetChannelConfig,
  useUpdateChannelConfig,
} from "./channels";

// Provider hooks
export {
  useGetProviders,
  useGetProvider,
  useGetProvidersByChannel,
  useUpdateProviderStatus,
} from "./providers";

// Template hooks
export {
  useGetTemplates,
  useGetTemplate,
  useCreateTemplate,
  useUpdateTemplate,
  useDeleteTemplate,
} from "./templates";

// Made with Bob
